import React from "react"
import DateTimeField from "components/Common/DateTimeField"
import { Label } from "reactstrap"
import Select from "react-select"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import { capitalize } from "lodash"
import { withFloatingSurface } from "components/Common/selectSurface"

const statusOptions = [
  { label: "Activated", value: "activated" },
  { label: "Blocked", value: "blocked" },
  { label: "Pending", value: "pending" },
  { label: "Deleted", value: "deleted" },
]

const bookingOptions = [
  { label: "Enabled", value: "yes" },
  { label: "Disabled", value: "no" },
]

const selectedOption = (options, value) =>
  options.find(option => String(option.value) === String(value)) || null

const FilterField = ({
  label,
  name,
  options,
  value,
  onChange,
  placeholder,
}) => (
  <div className="club-filter-field">
    <Label htmlFor={`club-filter-${name}`}>{label}</Label>
    <Select styles={withFloatingSurface()}
      inputId={`club-filter-${name}`}
      placeholder={placeholder || "All"}
      name={name}
      onChange={option => onChange(name, option)}
      options={options}
      value={selectedOption(options, value)}
      isClearable
      classNamePrefix="club-filter-select"
    />
  </div>
)

export const FilterList = ({
  advancedFilters,
  filters,
  setFilters,
  locations,
  settings,
}) => {
  const locationOptions = (locations || []).map(location => {
    const place = [location?.city, location?.country]
      .filter(Boolean)
      .join(", ")
    const count = Number.isFinite(Number(location?.total))
      ? ` (${location.total})`
      : ""

    return {
      label: `${place || location?.name || "Unknown location"}${count}`,
      value: `${location?.city ?? "null"}, ${location?.country}`,
    }
  })
  const activeSports = (settings?.activeSports || []).map(sport => ({
    label: capitalize(sport),
    value: sport,
  }))

  const handleSelectFilter = (name, option) => {
    const updatedFilters = { ...filters }

    if (option) {
      updatedFilters[name] = option.value
    } else {
      delete updatedFilters[name]
    }

    setFilters(updatedFilters)
  }

  const handleDateFilter = event => {
    const { name, value } = event.target
    const updatedFilters = { ...filters }

    if (value) {
      updatedFilters[name] = value
    } else {
      delete updatedFilters[name]
    }

    setFilters(updatedFilters)
  }

  return (
    <div className="club-filters">
      <div className="club-filters-primary">
        <FilterField
          label="Location"
          name="location"
          options={locationOptions}
          value={filters.location}
          onChange={handleSelectFilter}
        />
        <FilterField
          label="Sport"
          name="sportType"
          options={activeSports}
          value={filters.sportType}
          onChange={handleSelectFilter}
        />
        <FilterField
          label="Status"
          name="status"
          options={statusOptions}
          value={filters.status}
          onChange={handleSelectFilter}
        />
        <FilterField
          label="Booking"
          name="bookingEnabled"
          options={bookingOptions}
          value={filters.bookingEnabled}
          onChange={handleSelectFilter}
        />
      </div>

      {advancedFilters && (
        <div className="club-filters-secondary">
          <div className="club-filter-field">
            <Label htmlFor="club-filter-fromDate">Created from</Label>
            <DateTimeField
              id="club-filter-fromDate"
              name="fromDate"
              mode="date"
              rangeEnd={filters.toDate || ""}
              value={filters.fromDate || ""}
              onChange={handleDateFilter}
            />
          </div>
          <div className="club-filter-field">
            <Label htmlFor="club-filter-toDate">Created to</Label>
            <DateTimeField
              id="club-filter-toDate"
              name="toDate"
              mode="date"
              rangeStart={filters.fromDate || ""}
              value={filters.toDate || ""}
              onChange={handleDateFilter}
            />
          </div>
        </div>
      )}
    </div>
  )
}

const mapStateToProps = ({ session }) => ({
  settings: session.settings,
})

export default connect(mapStateToProps)(withRouter(FilterList))
